/**
 * Product Tabs Manager - Moon Moon Agency
 * Gere le changement d'onglet d'informations produit (description, tailles, composition, livraison)
 */

/*********************************************************************************************
 * 📑 PRODUCT TABS MANAGER
 */
const ProductTabsManager = {
	config: {
		selectors: {
			container: '.mm-product-onglets',
			tab: '[data-onglet-tab]',
			panel: '[data-onglet-panel]',
			anchor: 'a[href^="#mm-onglet-"]',
		},
		classes: {
			active: 'mm-product-onglets__tab--active',
		},
	},

	/**
	 * Initialize the module
	 */
	init() {
		const container = window.getElement(this.config.selectors.container);
		if (!container) return; // Guard clause : sortie silencieuse si absent du DOM

		this._bindEvents();
		window.log('info', '📑 [PRODUCT_TABS]', 'Initialized');
	},

	_bindEvents() {
		document.addEventListener('click', (e) => {
			const tab = e.target.closest(this.config.selectors.tab);
			if (tab) {
				this.activate(tab);
				return;
			}

			const anchor = e.target.closest(this.config.selectors.anchor);
			if (!anchor) return;
			this._handleAnchorClick(e, anchor);
		});

		document.addEventListener('keydown', (e) => {
			const tab = e.target.closest(this.config.selectors.tab);
			if (!tab) return;
			this._handleKeydown(e, tab);
		});
	},

	_handleAnchorClick(e, anchor) {
		const index = anchor.getAttribute('href').replace('#mm-onglet-', '');
		const tab = window.getElement(`[data-onglet-tab="${index}"]`);
		if (!tab) return;

		e.preventDefault();
		this.activate(tab);
		tab.scrollIntoView({ behavior: 'smooth', block: 'center' });
	},

	activate(tab) {
		const tabs = window.getElements(this.config.selectors.tab);
		const panels = window.getElements(this.config.selectors.panel);
		const index = tab.dataset.ongletTab;

		tabs.forEach((t) => {
			const isActive = t.dataset.ongletTab === index;
			t.classList.toggle(this.config.classes.active, isActive);
			t.setAttribute('aria-selected', String(isActive));
			t.setAttribute('tabindex', isActive ? '0' : '-1');
		});

		panels.forEach((panel) => {
			const isActive = panel.dataset.ongletPanel === index;
			panel.toggleAttribute('hidden', !isActive);
		});

		window.emit('global:product-tab-changed', { index });
	},

	_handleKeydown(e, tab) {
		const navigationKeys = ['ArrowLeft', 'ArrowRight', 'Home', 'End'];
		if (!navigationKeys.includes(e.key)) return;

		e.preventDefault();
		const tabs = Array.from(window.getElements(this.config.selectors.tab));
		const currentIndex = tabs.indexOf(tab);
		let nextIndex = currentIndex;

		if (e.key === 'ArrowRight') nextIndex = (currentIndex + 1) % tabs.length;
		if (e.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
		if (e.key === 'Home') nextIndex = 0;
		if (e.key === 'End') nextIndex = tabs.length - 1;

		tabs[nextIndex].focus();
		this.activate(tabs[nextIndex]);
	},
};

// Auto-init avec vérification readyState
if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', () => ProductTabsManager.init());
} else {
	ProductTabsManager.init();
}
